module.exports = __webpack_public_path__ + "media/images/products/products/v2-d650d215b1e082ade781dcc542f15d8f.jpg";